import PreRead from '@assets/icons/pre-read.svg'
import { Icon } from './Icon'

export const PreReadIcon = Icon(PreRead)
